<template>
  <b-form-group style="z-index: 1050; white-space: nowrap" :label="labelFormGroupBind"
    :class="`${classFormGroupBind} b-form-group-select-styled`" :invalid-feedback="invalidFeedback"
    :description="!error || !error.$error ? description : ''" :state="error && error.$error ? false : null"
    :disabled="disabled">
    <v-select :options="records" :getOptionLabel="(selected) => selected[label]" :filterable="false" :value="selected"
      @input="setSelected" @open="onOpen" @close="onClose" @search="onQuery" :append-to-body="appendToBody"
      class="b-form-select form-control" :state="error && error.$error ? false : null" :disabled="disabled">
      <template #no-options>Desculpe, sem registros para mostrar</template>
      <template #list-footer v-if="hasNextPage">
        <li ref="load" class="loader">Carregando mais registros...</li>
      </template>
    </v-select>
  </b-form-group>
</template>
<script>
export default {
  props: {
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    labelFormGroupBind: String,
    value: [Object, String, Number],
    label: String,
    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "Digite um valor válido",
    },
    error: {
      type: Object,
      default: null,
    },
    adicionarTodos:{
      type:Boolean,
      default: true,
    },
    loadFunction: Function,
    appendToBody: {
      typeof: Boolean,
      default: false,
    },
    disabled: {
      typeof: Boolean,
      default: false,
    },
    filterList: {
      typeof: Boolean,
      default: false,
    },
  },
  data() {
    return {
      observer: null,
      filter: "",
      records: [],
      page: 1,
      lastPage: 0,
      debounce: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.load();
  },
  computed: {
    selected() {
      return this.value;
    },
    hasNextPage() {
      return this.page < this.lastPage;
    },
    filteredAttrs() {
      const alowedKeys = ["label", "class"];
      return alowedKeys.reduce(
        (obj, key) => ({ ...obj, [key]: this.$attrs[key] }),
        {}
      );
    },
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
        (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
        (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
      return `${responsiveCols} ${this.classFormGroup}`;
    },
  },
  methods: {
    setSelected(value) {
      this.$emit("input", value);
    },
    onQuery(query) {
      this.filter = query;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.records = [];
        this.load();
      }, 600);
    },
    async load() {
      const { filter, page } = this;
      const { data: resp } = await this.loadFunction({ filter, page });
      if (this.filterList&& this.adicionarTodos) {
        this.records.push({ id: null, descricao: "Todos" });
      }
      this.records.push(...resp.content);
      this.lastPage = resp.totalPages;
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const { scrollTop } = target.offsetParent;
        this.page += 1;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}


.b-form-group-select-styled div .vs__dropdown-toggle {
  margin-left: -19px;
  border: unset;
  z-index: 10000;
}

</style>
